import React from 'react';
import { IconProps } from '../static/common';

export const ErrorImg: React.FC<IconProps> = ({
  fill = '#323234'
}) => (
  <svg
    width="1782"
    height="143"
    viewBox="0 0 1782 143"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M832.087 33.4142C839.433 33.4142 845.389 39.3694 845.389 46.7155C845.389 54.0616 839.433 60.0168 832.087 60.0168L772.675 60.0168L772.675 33.4142L832.087 33.4142Z"
      fill="white"
      stroke="#025181"
      strokeWidth="5.32053"
    />
    <path
      d="M601.226 62.7735L601.226 86.2265L1.7735 86.2265L1.7735 62.7735L601.226 62.7735Z"
      fill="#FBFBFB"
      stroke="#0A5683"
      strokeWidth="3.54702"
    />
    <path
      d="M832.087 84.8458C839.433 84.8458 845.389 90.801 845.389 98.1471C845.389 105.493 839.433 111.448 832.087 111.448L772.675 111.448L772.675 84.8458L832.087 84.8458Z"
      fill="white"
      stroke="#025181"
      strokeWidth="5.32053"
    />
    <path
      d="M656.51 43.1683C656.51 27.4966 669.214 14.7921 684.886 14.7921H773.562V130.07H681.339C667.626 130.07 656.51 118.954 656.51 105.241V43.1683Z"
      fill="#CFE0EE"
      stroke="#025181"
      strokeWidth="7.09404"
    />
    <path
      d="M601.531 59.1301C601.531 52.2737 607.09 46.7155 613.946 46.7155H654.737V103.468H610.399C605.502 103.468 601.531 99.4977 601.531 94.6002V59.1301Z"
      fill="#CFE0EE"
      stroke="#025181"
      strokeWidth="7.09404"
    />
    <rect
      x="771.788"
      y="4.15102"
      width="24.8291"
      height="134.787"
      fill="#CFE0EE"
      stroke="#025181"
      strokeWidth="7.09404"
    />
    <path
      d="M1181.77 62.7735L1181.77 86.2265L1780.23 86.2265L1780.23 62.7735L1181.77 62.7735Z"
      fill="#FBFBFB"
      stroke="#0A5683"
      strokeWidth="3.54702"
    />
    <path
      d="M1126.49 43.1683C1126.49 27.4966 1113.79 14.7921 1098.11 14.7921H1009.44V130.07H1101.66C1115.37 130.07 1126.49 118.954 1126.49 105.241V43.1683Z"
      fill="#CFE0EE"
      stroke="#025181"
      strokeWidth="7.09404"
    />
    <path
      d="M1181.47 59.1301C1181.47 52.2737 1175.91 46.7155 1169.05 46.7155H1128.26V103.468H1172.6C1177.5 103.468 1181.47 99.4977 1181.47 94.6002V59.1301Z"
      fill="#CFE0EE"
      stroke="#025181"
      strokeWidth="7.09404"
    />
    <rect
      x="-3.54702"
      y="3.54702"
      width="24.8291"
      height="134.787"
      transform="matrix(-1 0 0 1 1007.66 0.604004)"
      fill="#CFE0EE"
      stroke="#025181"
      strokeWidth="7.09404"
    />
  </svg>
);
